import { render, staticRenderFns } from "./AuctionWorkPage.vue?vue&type=template&id=43a90fe2&"
import script from "./AuctionWorkPage.vue?vue&type=script&lang=js&"
export * from "./AuctionWorkPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports